import GeneralButton from "../common/GeneralButton";
import Icon from "../common/Icon";
import { usePlan, useStep } from "../contexts/SubscriptionContext";
import { useNavigate } from "react-router-dom";
import { GiMeal } from "react-icons/gi";
const PlanCard = ({ item }) => {
  const { setSelectedPlan } = usePlan();
  const navigate = useNavigate();
  const { goToStep } = useStep();
  return (
    <div
      // onClick={() => {
      //   setSelectedPlan(item);
      //   goToStep("1");
      //   navigate("/subscribe/plan");
      // }}
      // title="Click to select plan"
      className="bg-[#fff] relative  xxs:py-10 md:py-6 px-10 grid min-h-[197px]  gap-4 xl:gap-10  md:grid-cols-[2.2fr_5fr] lg:grid-cols-[1.4fr_5fr]  xl:grid-cols-[1.4fr_5fr] 2xl:grid-cols-[1.1fr_5fr] 2.5xl:grid-cols-[0.8fr_5fr] rounded-[25px]  transition-transform duration-300 "
    >
      {/* --- Column 1: Text content --- */}
      <div className="flex flex-col justify-center  text-secondary">
        <div className="relative">
          {item.specialOfferText && (
            <p
              style={{ color: item.specialOfferTextColor }}
              className="absolute -top-6 md:-top-5 left-0 text-14pt md:text-xs font-mono text-secondary capitalize"
            >
              {item.specialOfferText}
            </p>
          )}
          {item.priceBadgeText && (
            <GeneralButton
              text={item.priceBadgeText}
              className="text-18pt  mb-1 xl:py-1 cursor-default px-4"
              bgColor={item.priceBadgeColor}
              textColor={item.badgeTextColor || "#fff"}
              icon={null}
            />
          )}
          <h2 className="2.5xl:text-48pt xl:text-40pt lg:text-32pt md:text-32pt xxs:text-32pt leading-none mt-2 text-secondary text-nowrap  capitalize ">
            {item.title}
          </h2>
          <h2 className="xl:text-32pt lg:text-24pt md:text-24pt text-32pt leading-tight text-secondary">
            plan
          </h2>
        </div>
      </div>

      {/* --- Column 2: Image --- */}
      <div className="relative flex flex-col items-start justify-center ">
        <p
          className="text-24pt leading-relaxed font-mono abouthtml max-w-[80%]"
          dangerouslySetInnerHTML={{ __html: item.description }}
        ></p>
        {item.boxType && (
          <p className="text-[14px] text-orange mt-4 leading-relaxed font-mono ">
            *{item.boxType}
          </p>
        )}
        {/* <GeneralButton
          text="View Meals"
          title=""
          bgColor="#A0AE3F"
          className="text-24pt lg:text-20pt 1xl:text-[23.5px] leading-tight cursor-pointer mt-5"
          onClick={() => {
            navigate("/meals");
          }}
          textType=""
          // icon={
          //   <HiChevronRight className="text-24pt hidden md:block" />
          // }
        /> */}
        <div>
          <div
            title="Click to select plan"
            onClick={() => {
              setSelectedPlan(item);
              goToStep("1");
              navigate("/subscribe/plan");
            }}
            // title="Click to select plan"
            className="absolute cursor-pointer hover:text-orange  -right-4 -bottom-4 md:-bottom-2 md:-right-4 bg-white rounded-full transition-colors"
          >
            <Icon icon="plus" className="w-10 h-10" />
          </div>
          {/* <div
            title="Click to view meals"
            onClick={() => {
              setSelectedPlan(item);
              goToStep("1");
              navigate("/subscribe/plan");
            }}
            // title="Click to select plan"
            className="absolute cursor-pointer text-quaternary hover:text-orange  -right-4 -bottom-4 md:bottom-12 md:-right-5 bg-white rounded-full transition-colors"
          >
            <GiMeal className="w-12 h-12" />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
